import React from "react";
import ComponenteConItemsForm from "./ComponenteConItemsForm";

export default function MaterialesFrioForm() {
  return (
    <ComponenteConItemsForm
      titulo="Materiales de Frío"
      tipo="materialesFrio"
    />
  );
}
